export default __webpack_public_path__ + "static/media/spratt13.04686e65.jpg";